import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Pagination from '../pagination';
import { PurchaseAction } from '../../store/actions';

class List extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    deletePurchase: PropTypes.func,
    getPurchases: PropTypes.func,
    location: PropTypes.object,
    permissions: PropTypes.arrayOf(PropTypes.string),
    purchases: PropTypes.object,
    restorePurchase: PropTypes.func,
  };

  componentDidMount() {
    this.props.getPurchases(
      Object.fromEntries(new URLSearchParams(this.props.location.search)),
    );
  }

  onDelete(row) {
    if (!confirm('Are you sure?')) {
      return;
    }
    this.props.deletePurchase(row.id);
  }

  onRestore(row) {
    if (!confirm('Are you sure?')) {
      return;
    }
    this.props.restorePurchase(row.id);
  }

  onSearch(event) {
    const {
      target: { value },
    } = event;
    this.props.getPurchases({ query: value });
  }

  render() {
    const {
      authHasOffice = false,
      getPurchases = () => {},
      location = {},
      permissions = [],
      purchases: { data: purchases = [], links = [] } = {},
    } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Purchase</h3>
              <div className="card-tools d-print-none">
                <Pagination
                  getList={getPurchases}
                  links={links}
                  location={location}
                />
              </div>
              <div className="card-tools d-print-none mr-2">
                <div
                  className="input-group input-group-sm"
                  style={{ width: '150px' }}
                >
                  <input
                    className="form-control"
                    onChange={this.onSearch.bind(this)}
                    placeholder="Search"
                    type="text"
                  />
                </div>
              </div>
              {permissions?.includes?.('purchase.create') && (
                <div className="card-tools d-print-none mr-2">
                  <div className="input-group input-group-sm">
                    <Link
                      className="btn btn-primary btn-sm"
                      to={`${this.props.match?.path}/create`}
                    >
                      <i className="fas fa-plus-square mr-1"></i>
                      Create
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <div className="card-body p-0 table-responsive">
              {purchases?.length === 0 && (
                <p className="text-center my-2">No data found.</p>
              )}
              {purchases?.length > 0 && (
                <table className="table table-striped text-nowrap">
                  <thead>
                    <tr>
                      {permissions?.some?.(p =>
                        ['purchase.delete', 'purchase.edit']?.includes?.(p),
                      ) && (
                        <th
                          className="d-print-none"
                          style={{ minWidth: '175px' }}
                        >
                          Action
                        </th>
                      )}
                      {!authHasOffice && <th>Office</th>}
                      <th>ID</th>
                      <th>Purchased At</th>
                      <th>Chalan Number</th>
                      <th>Model</th>
                      <th>Chassis Number</th>
                      <th>Engine Number</th>
                      <th>Key Number</th>
                      <th>Color</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {purchases?.map?.(row => (
                      <tr key={row.id}>
                        {permissions?.some?.(p =>
                          ['purchase.delete', 'purchase.edit']?.includes?.(p),
                        ) && (
                          <td className="d-print-none">
                            <div className="btn-group">
                              {permissions?.includes?.('purchase.edit') && (
                                <Link
                                  className="btn btn-info btn-sm"
                                  to={`${this.props.match?.path}/${row.id}/edit`}
                                >
                                  <i className="fas fa-edit mr-1"></i>
                                  Edit
                                </Link>
                              )}
                              {permissions?.includes?.('purchase.delete') && !row.deleted_at && (
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => this.onDelete(row)}
                                  type="button"
                                >
                                  <i className="fas fa-trash mr-1"></i>
                                  Delete
                                </button>
                              )}
                              {permissions?.includes?.('purchase.restore') && row.deleted_at && (
                                <button
                                  className="btn btn-warning btn-sm"
                                  onClick={() => this.onRestore(row)}
                                  type="button"
                                >
                                  <i className="fas fa-trash-restore mr-1"></i>
                                  Restore
                                </button>
                              )}
                            </div>
                          </td>
                        )}
                        {!authHasOffice && <td>{row.office?.name}</td>}
                        <td>{row.id}</td>
                        <td>{row.purchased_at}</td>
                        <td>{row.chalan_number}</td>
                        <td>{row.vehicle?.model}</td>
                        <td>{row.chassis_number}</td>
                        <td>{row.engine_number}</td>
                        <td>{row.key_number}</td>
                        <td>{row.color?.name}</td>
                        <td>{row.price}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authHasOffice: !!state?.auth?.office,
  permissions: state?.auth?.permissions,
  purchases: state?.purchase?.list,
});

const mapDispatchToProps = dispatch => ({
  deletePurchase: id => dispatch(PurchaseAction.deletePurchase(id)),
  getPurchases: params => dispatch(PurchaseAction.getPurchases(params)),
  restorePurchase: id => dispatch(PurchaseAction.restorePurchase(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(List);
